module.exports = __webpack_public_path__ + "assets/c5a89f2587cb7b113c53b929da5aac8c.mp3";